// extracted by mini-css-extract-plugin
export default {"pageHeader":"AdminMailing_pageHeader__-5FRo","tableTitleWrapper":"AdminMailing_tableTitleWrapper__PSYsh"};